import { createApi } from '@reduxjs/toolkit/query/react';
import { HttpMethod } from '@vision/ui/enums';
import { axiosBaseQuery } from './base.service';
import { ApiResponse, ELCSurveyTriggerLog } from '../interfaces';

export const ELCSurveyTriggerLogsService = createApi({
  reducerPath: 'ELCSurveyTriggerLogsService',
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    getELCSurveyTriggerLogs: builder.query<ApiResponse<ELCSurveyTriggerLog[]>, { nodeId: string; query?: string }>({
      query: ({ nodeId, query }) => ({
        url: `/v2/accounts/${nodeId}/survey_trigger_logs${query ? `?${query}` : ''}`,
        method: HttpMethod.GET,
      }),
    }),
  }),
});

export const { useLazyGetELCSurveyTriggerLogsQuery } = ELCSurveyTriggerLogsService;
